import Follower from "../models/Follower";
import PayloadContext from "@/models/PayloadContext";
import AlarmSpeed from "../models/AlarmSpeed";
import Process from "../models/Process";
import Download from "../models/Download";

const strategies = {
	Follower,
	AlarmSpeed,
	Process,
	Download,
};

/**
 *
 * @param {Object} params Object with the parameters to use in the payload
 * @param {string} type can be user or truck
 * @returns Object with the payload to use in the request
 */
export const payloadGenerator = (data, type, method = "fetch") => {
	switch (method) {
		case "fetch":
			return toFetchFilter(data, type);
		case "search":
			return toSearchFilter(data, type);
		case "create":
			return toCreate(data, type);
		case "update":
			return toUpdate(data, type);
		default:
			return {};
	}
};

const toFetchFilter = (data, type) => {
	const {page, quantity, fields, sort, filters, order_by, order_sort} = data;

	const payload = {
		page: page ? page : 1,
		quantity: quantity ? quantity : 100000,
		fields: fields && fields.length > 0 ? fields : resolveFields(type),
		match_filter: true,
	};

	if (sort && sort.length > 0) {
		payload.sort = sort;
	}

	if (order_by && order_by.length > 0) {
		payload.order_by = order_by;
	}
	// add all of properties of filters object to payload

	if (order_sort && Object.keys(order_sort).length > 0) {
		payload.order_sort = order_sort;
	}

	if (filters && Object.keys(filters).length > 0) {
		Object.keys(filters).forEach((key) => {
			payload[key] = filters[key];
		});
	}
	return payload;
};

const toSearchFilter = (data, type) => {
	const {page, quantity, fields, filters, order_sort, match_filter, logical_operator} = data;

	const payload = {
		page: page ? page : 1,
		quantity: quantity ? quantity : 100000,
		fields: fields && fields.length > 0 ? fields : resolveFields(type),
		match_filter: match_filter !== undefined ? match_filter : true,
		logical_operator: logical_operator !== undefined ? logical_operator : "and",
	};

	if (order_sort) {
		payload.order_sort = order_sort;
	}

	if (filters && Object.keys(filters).length > 0) {
		payload.filters = {...filters};
	}

	return payload;
};

const toCreate = (data, type) => {
	const payloadContext = new PayloadContext(null);
	const StrategyClass = strategies[type];
	payloadContext.setStrategy(new StrategyClass(data));
	return payloadContext.getPayloadToCreate();
};

const toUpdate = (data, type) => {
	const payload = new PayloadContext(null);

	const StrategyClass = strategies[type];

	payload.setStrategy(new StrategyClass(data));

	return payload.getPayloadToUpdate();
};

/**
 * @description Resolve the fields for the payload to fetch the data from the server
 * also use the strategy pattern to create the payload object to use in the request
 *
 * @param {string} type can be user or truck
 * @returns Array with the fields to use in the payload
 */
const resolveFields = (type) => {
	const payloadContext = new PayloadContext(null);

	const StrategyClass = strategies[type];
	payloadContext.setStrategy(new StrategyClass({}));

	return payloadContext.getPayloadToFetch();
};
